import {
  BaseActionObject,
  DoneInvokeEvent,
  StateNodeConfig,
  assign
} from "xstate4"
import { getServiceErrorMessage } from "../helpers"
import { Context, Transitions } from "../types"

export const fetchStudyPlanTransition: StateNodeConfig<
  Context,
  {},
  Transitions,
  BaseActionObject
> = {
  invoke: {
    src: "fetchDraftStudyPlan",
    onDone: [
      {
        target: "edit_plan",
        actions: assign<Context, DoneInvokeEvent<any>>({
          studyPlan: (_ctx, evt) => evt.data.plan
        }),
        cond: (_ctx, evt) => {
          return evt.type === "EDIT"
        }
      },
      {
        target: "review_plan",
        actions: assign<Context, DoneInvokeEvent<any>>({
          studyPlan: (_ctx, evt) => evt.data.plan
        })
        // WIP: Teacher state
        // cond: (_ctx, evt) => {
        //   console.log(evt.type, "VIEW", evt.type === "VIEW")
        //   return evt.type === "VIEW"
        // }
      }
    ],
    onError: {
      target: "#StudyPlan.study_plans_overview.idle",
      actions: assign<Context, DoneInvokeEvent<any>>({
        snackbar: (_ctx, _evt) => ({
          message: getServiceErrorMessage("fetchDraftStudyPlan", {
            messageData: ["fetch the selected study plan"]
          }),
          withUndo: false,
          error: true
        })
      })
    }
  }
}
